import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import Swal from "sweetalert2";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import * as XLSX from "xlsx";
import * as Icon from "react-bootstrap-icons";

function AddClinic() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [cliName, setCliName] = useState("");
    const [cliCode, setCliCode] = useState("");
    const [cliContact, setCliContact] = useState("");
    const [cliAddress, setCliAddress] = useState("");
    const [cliCountry, setCliCountry] = useState("");
    const [cliState, setCliState] = useState("");
    const [cliDistrict, setCliDistrict] = useState("");
    const [cntry_name, setcntry_name] = useState("");
    const [state_name, setstate_name] = useState("");
    const [district_name, setdistrict_name] = useState("");
    const [cliPin, setCliPin] = useState("");
    const [cliCoord, setCliCoord] = useState("");
    const [cliEmail, setCliEmail] = useState("");
    const [cliWebsite, setCliWebsite] = useState("");
    const [cliServedBy, setCliServedBy] = useState("");
    const [staffList, setStaffList] = useState([]);

    // ── Tab ──────────────────────────────────────────────────────────────────
    const [activeTab, setActiveTab] = useState("manual");

    // ── Bulk-upload state ────────────────────────────────────────────────────
    const [bulkRows, setBulkRows] = useState([]);
    const [bulkColumns, setBulkColumns] = useState([]);
    const [bulkFileName, setBulkFileName] = useState("");
    const [bulkUploading, setBulkUploading] = useState(false);
    const [bulkResults, setBulkResults] = useState(null);

    let navigate = useNavigate();

    useEffect(() => {
        const getcountry = () => {
            axios
                .get(baseurladdress + "staff/getallcountry", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        const options = res.data.countries.map((item) => (
                            <option key={item.cntry_id} value={item.cntry_id}>
                                {item.cntry_name}
                            </option>
                        ));

                        setcntry_name(options);
                    } else {
                        setcntry_name([]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    alert("Failed to load countries");
                });
        };

        getcountry();
    }, []);

    // Added: Fetch staff list
    useEffect(() => {
        const getAllStaff = async () => {
            try {
                const res = await axios.get(baseurladdress + "staff/findallstaff", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                });
                if (res.data.status === "Success") {
                    setStaffList(res.data.staff || []);
                } else {
                    setStaffList([]);
                }
            } catch (err) {
                console.error(err);
                setStaffList([]);
            }
        };
        getAllStaff();
    }, [accesstoken]);

    const changeTitle = (staffcntry) => {
        axios
            .get(baseurladdress + "staff/getstates/" + staffcntry, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.states.map((item) => (
                        <option key={item.state_id} value={item.state_id}>
                            {item.state_name}
                        </option>
                    ));

                    setstate_name(options);
                } else {
                    setstate_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load states");
            });
    };

    const changeDistricts = (staffdistrict) => {
        axios
            .get(baseurladdress + "staff/getdistricts/" + staffdistrict, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.districts.map((item) => (
                        <option key={item.district_id} value={item.district_id}>
                            {item.district_name}
                        </option>
                    ));

                    setdistrict_name(options);
                } else {
                    setdistrict_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load districts");
            });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = {
            clinic_name: cliName,
            clinic_code: cliCode,
            contact: cliContact,
            country: cliCountry,
            state: cliState,
            district: cliDistrict,
            address: cliAddress,
            pincode: cliPin,
            coordinates: cliCoord,
            email: cliEmail,
            website: cliWebsite,
            userid: accessuserid,
            introby: accessuserid,
            clinic_servedby: cliServedBy, // Added staff assignment
        };

        fetch(baseurladdress + "clinic/addclinic", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.status === "Success") {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "success",
                        title: "Clinic added successfully",
                        showConfirmButton: false,
                        timer: 1800,
                    });
                    navigate("/clinics");
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed",
                        text: result.message || "Unable to add hospital",
                    });
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Server Error",
                    text: error.message,
                });
            });
    };

    // ════════════════════════════════════════════════════════════════════════
    // Bulk upload helpers
    // ════════════════════════════════════════════════════════════════════════
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setBulkFileName(file.name);
        setBulkResults(null);
        const reader = new FileReader();
        reader.onload = (evt) => {
            try {
                const wb = XLSX.read(evt.target.result, { type: "binary" });
                const ws = wb.Sheets[wb.SheetNames[0]];
                const raw = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
                if (raw.length === 0) {
                    Swal.fire({ icon: "warning", title: "Empty File", text: "The Excel file has no data." });
                    setBulkFileName(""); return;
                }
                const headerRowIndex = raw.findIndex(
                    (row) => row.filter((cell) => String(cell).trim() !== "").length >= 2
                );
                if (headerRowIndex === -1) {
                    Swal.fire({ icon: "error", title: "Invalid File", text: "Could not detect a header row." });
                    setBulkFileName(""); return;
                }
                const json = XLSX.utils.sheet_to_json(ws, { range: headerRowIndex, defval: "" });
                if (json.length === 0) {
                    Swal.fire({ icon: "warning", title: "Empty File", text: "The Excel file has no data rows." }); return;
                }
                setBulkColumns(Object.keys(json[0]));
                setBulkRows(json);
            } catch {
                Swal.fire({ icon: "error", title: "Parse Error", text: "Could not read the file. Please use a valid .xlsx or .xls file." });
            }
        };
        reader.readAsBinaryString(file);
        e.target.value = "";
    };

    const removeRow = (idx) => setBulkRows((prev) => prev.filter((_, i) => i !== idx));

    const handleBulkSubmit = async () => {
        if (bulkRows.length === 0) return;
        const confirm = await Swal.fire({
            title: `Upload ${bulkRows.length} clinics?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Upload",
        });
        if (!confirm.isConfirmed) return;
        setBulkUploading(true);
        setBulkResults(null);
        try {
            const res = await axios.post(
                baseurladdress + "clinic/bulkaddclinics",
                { clinics: bulkRows, userid: accessuserid },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );
            const { success, failed, errors } = res.data;
            setBulkResults({ success, failed, errors });
            if (failed === 0) {
                Swal.fire({ toast: true, position: "top-end", icon: "success", title: `${success} clinic(s) added successfully!`, showConfirmButton: false, timer: 2500 });
                setBulkRows([]); setBulkColumns([]); setBulkFileName("");
            } else {
                Swal.fire({ icon: "warning", title: "Partial Upload", text: `${success} added, ${failed} failed. See error details below.` });
            }
        } catch (err) {
            Swal.fire({ icon: "error", title: "Upload Failed", text: err.response?.data?.error || err.message });
        } finally {
            setBulkUploading(false);
        }
    };

    return (
        <div className="staff-page">
            <div className="staff-container">
                <div className="staff-header">
                    <NavLink to="/clinics">
                        <div className="float">
                            <i className="fa fa-arrow-left my-float"></i>
                        </div>
                    </NavLink>
                </div>

                {/* ── Tab switcher ── */}
                <div style={styles.tabBar}>
                    <button
                        style={activeTab === "manual" ? { ...styles.tab, ...styles.tabActive } : styles.tab}
                        onClick={() => setActiveTab("manual")} type="button"
                    >
                        <Icon.PencilSquare style={{ marginRight: 6 }} /> Manual Entry
                    </button>
                    <button
                        style={activeTab === "bulk" ? { ...styles.tab, ...styles.tabActive } : styles.tab}
                        onClick={() => setActiveTab("bulk")} type="button"
                    >
                        <Icon.FileEarmarkExcel style={{ marginRight: 6 }} /> Bulk Upload (Excel)
                    </button>
                </div>

                {/* ══════════════════════════════════════════════════════════
                    MANUAL ENTRY TAB
                ══════════════════════════════════════════════════════════ */}
                {activeTab === "manual" && (
                    <form onSubmit={handleSubmit} className="staff-form">
                        <div className="staff-columns">

                            {/* LEFT COLUMN */}
                            <div className="staff-column">
                                <div className="staff-card">
                                    <div className="staff-card-body">

                                        <div className="card-header">
                                            <h4 className="card-title">ADD CLINIC</h4>
                                            <div className="staff-heading-divider"></div>
                                        </div>

                                        <div className="staff-fields">

                                            <div className="staff-group">
                                                <label>Clinic Name <span className="staff-required">*</span></label>
                                                <input
                                                    type="text"
                                                    onChange={(e) => setCliName(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="staff-group">
                                                <label>Clinic Code <span className="staff-required">*</span></label>
                                                <input
                                                    type="text"
                                                    onChange={(e) => setCliCode(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="staff-group">
                                                <label>Contact <span className="staff-required">*</span></label>
                                                <input
                                                    type="text"
                                                    onChange={(e) => setCliContact(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="staff-group">
                                                <h6><span style={{ "color": "red" }}>*</span>Country </h6>
                                                <select
                                                    className="form-control select"
                                                    name="Country"
                                                    onChange={e => { changeTitle(e.target.value); setCliCountry(e.target.value) }}
                                                >
                                                    <option value="" disabled selected>
                                                        Select
                                                    </option>
                                                    {cntry_name}
                                                </select>
                                            </div>

                                            <div className="staff-group">
                                                <h6><span style={{ "color": "red" }}>*</span>State </h6>
                                                <select
                                                    className="form-control select"
                                                    name="State"
                                                    onChange={e => { changeDistricts(e.target.value); setCliState(e.target.value) }}
                                                >
                                                    <option value="" disabled selected>
                                                        Select
                                                    </option>
                                                    {state_name}
                                                </select>
                                            </div>

                                            <div className="staff-group">
                                                <h6><span style={{ "color": "red" }}>*</span>District </h6>
                                                <select
                                                    className="form-control select"
                                                    name="District"
                                                    onChange={(e) => setCliDistrict(e.target.value)}
                                                >
                                                    <option value="" disabled selected>
                                                        Select
                                                    </option>
                                                    {district_name}
                                                </select>
                                            </div>

                                            {/* Added: Served By (Staff) field */}
                                            <div className="staff-group">
                                                <h6>Served By (Staff)</h6>
                                                <select
                                                    className="form-control select"
                                                    name="clinic_servedby"
                                                    value={cliServedBy}
                                                    onChange={(e) => setCliServedBy(e.target.value)}
                                                >
                                                    <option value="">Select Staff</option>
                                                    {staffList.map((staff) => (
                                                        <option key={staff.staff_id} value={staff.staff_id}>
                                                            {staff.staff_name} - {staff.staff_code}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* RIGHT COLUMN */}
                            <div className="staff-column">
                                <div className="staff-card">
                                    <div className="staff-card-body">

                                        <div className="staff-fields">

                                            <div className="staff-group">
                                                <label>Address <span className="staff-required">*</span></label>
                                                <textarea
                                                    rows="3"
                                                    onChange={(e) => setCliAddress(e.target.value)}
                                                    required
                                                ></textarea>
                                            </div>

                                            <div className="staff-group">
                                                <label>Pincode <span className="staff-required">*</span></label>
                                                <input
                                                    type="text"
                                                    onChange={(e) => setCliPin(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="staff-group">
                                                <label>Email</label>
                                                <input
                                                    type="email"
                                                    onChange={(e) => setCliEmail(e.target.value)}
                                                />
                                            </div>

                                            <div className="staff-group">
                                                <label>Website</label>
                                                <input
                                                    type="url"
                                                    onChange={(e) => setCliWebsite(e.target.value)}
                                                />
                                            </div>

                                            <div className="staff-group">
                                                <label>Coordinates</label>
                                                <input
                                                    type="text"
                                                    placeholder="Lat, Long"
                                                    onChange={(e) => setCliCoord(e.target.value)}
                                                />
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="staff-btn-container">
                            <button type="submit" className="staff-btn">Submit</button>
                        </div>
                    </form>
                )}

                {/* ══════════════════════════════════════════════════════════
                    BULK UPLOAD TAB
                ══════════════════════════════════════════════════════════ */}
                {activeTab === "bulk" && (
                    <div className="staff-form">
                        <div className="staff-card">
                            <div className="staff-card-body">
                                <div className="card-header">
                                    <h4 className="card-title">BULK UPLOAD CLINICS</h4>
                                    <div className="staff-heading-divider"></div>
                                </div>

                                {/* Step 1 – Upload File */}
                                <div style={styles.stepBlock}>
                                    <p style={styles.stepLabel}><span style={styles.stepBadge}>1</span> Upload your Excel file</p>
                                    <label style={styles.fileLabel} htmlFor="bulkFileInput">
                                        <Icon.FileEarmarkArrowUp size={28} />
                                        <span style={{ marginTop: 6 }}>
                                            {bulkFileName ? bulkFileName : "Click to choose .xlsx / .xls file"}
                                        </span>
                                        <input
                                            id="bulkFileInput"
                                            type="file"
                                            accept=".xlsx,.xls"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}
                                        />
                                    </label>
                                </div>

                                {/* Step 2 – Preview & Submit */}
                                {bulkRows.length > 0 && (
                                    <div style={styles.stepBlock}>
                                        <p style={styles.stepLabel}>
                                            <span style={styles.stepBadge}>2</span>
                                            Preview &amp; Submit &nbsp;
                                            <span style={styles.rowCountBadge}>{bulkRows.length} row{bulkRows.length > 1 ? "s" : ""}</span>
                                        </p>
                                        <div style={styles.tableWrapper}>
                                            <table style={styles.table}>
                                                <thead>
                                                    <tr style={styles.theadRow}>
                                                        <th style={styles.th}>#</th>
                                                        {bulkColumns.map((col) => <th key={col} style={styles.th}>{col}</th>)}
                                                        <th style={styles.th}>Remove</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bulkRows.map((row, idx) => (
                                                        <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                                            <td style={styles.td}>{idx + 1}</td>
                                                            {bulkColumns.map((col) => <td key={col} style={styles.td}>{row[col] ?? ""}</td>)}
                                                            <td style={styles.td}>
                                                                <button type="button" style={styles.removeBtn} onClick={() => removeRow(idx)} title="Remove row">
                                                                    <Icon.XCircle />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
                                            <button type="button" className="staff-btn" onClick={handleBulkSubmit} disabled={bulkUploading}>
                                                {bulkUploading
                                                    ? <><span className="spinner-border spinner-border-sm me-2" /> Uploading…</>
                                                    : <><Icon.CloudUpload style={{ marginRight: 6 }} /> Upload {bulkRows.length} Clinics</>
                                                }
                                            </button>
                                            <button type="button" style={styles.clearBtn}
                                                onClick={() => { setBulkRows([]); setBulkColumns([]); setBulkFileName(""); setBulkResults(null); }}>
                                                <Icon.Trash style={{ marginRight: 6 }} /> Clear
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Upload results */}
                                {bulkResults && (
                                    <div style={styles.resultsBox}>
                                        <p style={{ fontWeight: 600, marginBottom: 8 }}>Upload Summary</p>
                                        <p style={{ color: "#198754" }}>✅ {bulkResults.success} clinic(s) added successfully</p>
                                        {bulkResults.failed > 0 && (
                                            <>
                                                <p style={{ color: "#dc3545" }}>❌ {bulkResults.failed} row(s) failed</p>
                                                <div style={styles.errorList}>
                                                    {bulkResults.errors.map((e, i) => (
                                                        <p key={i} style={{ margin: "2px 0", fontSize: 13 }}>Row {e.row}: {e.reason}</p>
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
}

const styles = {
    tabBar: { display: "flex", gap: 4, marginBottom: 20, borderBottom: "2px solid #dee2e6" },
    tab: { padding: "10px 22px", border: "none", background: "transparent", borderBottom: "3px solid transparent", cursor: "pointer", fontSize: 14, fontWeight: 500, color: "#6c757d", display: "flex", alignItems: "center", transition: "all .2s" },
    tabActive: { borderBottom: "3px solid #0d6efd", color: "#0d6efd" },
    stepBlock: { marginBottom: 28 },
    stepLabel: { fontWeight: 600, fontSize: 15, display: "flex", alignItems: "center", gap: 8, marginBottom: 8 },
    stepBadge: { background: "#0d6efd", color: "#fff", borderRadius: "50%", width: 24, height: 24, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0 },
    rowCountBadge: { background: "#e9f0ff", color: "#0d6efd", borderRadius: 12, padding: "2px 10px", fontSize: 13 },
    fileLabel: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "2px dashed #adb5bd", borderRadius: 10, padding: "36px 24px", cursor: "pointer", color: "#495057", fontSize: 14, textAlign: "center", maxWidth: 420 },
    tableWrapper: { overflowX: "auto", border: "1px solid #dee2e6", borderRadius: 8, maxHeight: 360, overflowY: "auto" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
    theadRow: { background: "#f1f3f5", position: "sticky", top: 0, zIndex: 1 },
    th: { padding: "10px 12px", textAlign: "left", fontWeight: 600, whiteSpace: "nowrap", borderBottom: "2px solid #dee2e6" },
    trEven: { background: "#fff" },
    trOdd: { background: "#f8f9fa" },
    td: { padding: "8px 12px", whiteSpace: "nowrap", borderBottom: "1px solid #e9ecef", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis" },
    removeBtn: { background: "none", border: "none", color: "#dc3545", cursor: "pointer", padding: 0, fontSize: 16 },
    clearBtn: { display: "inline-flex", alignItems: "center", padding: "8px 16px", background: "#f8f9fa", color: "#dc3545", border: "1px solid #dc3545", borderRadius: 6, cursor: "pointer", fontWeight: 500, fontSize: 14 },
    resultsBox: { background: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: 8, padding: "16px 20px", marginTop: 8 },
    errorList: { background: "#fff5f5", border: "1px solid #f5c2c7", borderRadius: 6, padding: 10, marginTop: 6, maxHeight: 200, overflowY: "auto", color: "#842029", fontFamily: "monospace", fontSize: 13 },
};

export default AddClinic;